export enum LegalizationStatusEnum {
  ReadyForLegalization = 1,
  InProgress = 2,
  Approved = 3,
  Rejected = 4,
  AwaitingStatement = 5,
  AwaitingPermit = 6,
  MissingDocuments = 7,
  Draft = 8
}
